export default {"src":"/_next/static/media/BRT_Logo.85c23b8d.svg","height":142,"width":92};